import { render, staticRenderFns } from "./Chapters.vue?vue&type=template&id=47826db5&"
import script from "./Chapters.vue?vue&type=script&lang=js&"
export * from "./Chapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47826db5')) {
      api.createRecord('47826db5', component.options)
    } else {
      api.reload('47826db5', component.options)
    }
    module.hot.accept("./Chapters.vue?vue&type=template&id=47826db5&", function () {
      api.rerender('47826db5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Chapters.vue"
export default component.exports